<script setup lang="ts">
import type { ShowcaseContentResourceDto } from '@repo/api/web/models'

// документы материала (CMS MR 12): ссылки на файлы, имя — DisplayName из
// админки, иначе идентификатор ресурса (как в DocumentsSection товара)
const props = defineProps<{
  items: ShowcaseContentResourceDto[]
}>()

const { support } = useResources()

function documentUrl(resourceId: string) {
  return support.getResourceUrl(resourceId)
}

function documentName(document: ShowcaseContentResourceDto) {
  return document.displayName?.trim() || document.resourceId
}
</script>

<template>
  <section v-if="props.items.length" class="mt-10">
    <h2 class="mb-4 text-xl font-semibold">
      Документы
    </h2>
    <div class="flex flex-col gap-2">
      <a
        v-for="document in props.items"
        :key="document.resourceId"
        :href="documentUrl(document.resourceId)"
        target="_blank"
        rel="noopener noreferrer"
        class="flex min-w-0 items-center gap-3 rounded-xl border border-neutral-200 p-3 transition-colors hover:bg-neutral-50"
      >
        <UIcon name="i-lucide-file" class="size-5 shrink-0 text-neutral-500" />
        <span class="truncate">{{ documentName(document) }}</span>
      </a>
    </div>
  </section>
</template>
